"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPickListDropdown = exports.SinglePickListDropdown = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useOnClickOutside = require("../../utils/hooks/useOnClickOutside");

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _Icon = _interopRequireDefault(require("../Icon"));

var _PickListDropdown = require("./PickListDropdown.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 客製化下拉選單(多選)
 */
var PickListDropdown = function PickListDropdown(_ref) {
  var _ref$defaultTitle = _ref.defaultTitle,
      defaultTitle = _ref$defaultTitle === void 0 ? "標題" : _ref$defaultTitle,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      title = _useState4[0],
      setTitle = _useState4[1];

  var dropdownRef = (0, _react.useRef)();

  var intersection = function intersection(target, compare) {
    var arrSet = new Set(compare);
    var isFirst = true;
    return target.map(function (item) {
      if (arrSet.has(item.value)) {
        var newItem = _objectSpread(_objectSpread({}, item), {}, {
          checked: true
        });

        return newItem;
      }

      return item;
    });
  };

  var initOptions = function initOptions(data) {
    if (data.length === 0 || !data) return [];
    var nextData = data.map(function (item) {
      var checked = false;
      return _objectSpread(_objectSpread({}, item), {}, {
        checked: checked
      });
    });
    return intersection(nextData, value);
  };

  var newData = (0, _react.useMemo)(function () {
    return initOptions(options);
  }, [value, options]);
  (0, _useOnClickOutside.useOnClickOutside)(dropdownRef, function () {
    return setDropdownOpen(false);
  });

  var dropdownOpenHandler = function dropdownOpenHandler() {
    setDropdownOpen(!isDropdownOpen);
  };

  var checkboxChangeHandler = function checkboxChangeHandler(e, list) {
    var tmpOptions = _toConsumableArray(newData);

    var isChecked = e.target.checked;
    var existItemIndex = tmpOptions.findIndex(function (item) {
      return item.value === list.value;
    });
    tmpOptions[existItemIndex].checked = isChecked;
    var tmp = tmpOptions.filter(function (option) {
      return option.checked;
    });

    if (tmpOptions.filter(function (option) {
      return option.checked === true;
    }).length === 1) {
      setTitle(tmp[0].name);
    }

    var checkedGroup = tmpOptions.filter(function (item) {
      return item.checked === true;
    });
    onChange(checkedGroup.map(function (item) {
      return item.value;
    }));
  };

  var formateTitle = function formateTitle() {
    var checkedOptions = newData.filter(function (item) {
      return item.checked === true;
    });

    if (checkedOptions.length === 1) {
      return title || checkedOptions[0].name;
    } else if (checkedOptions.length > 1) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, title || checkedOptions[0].name), /*#__PURE__*/_react.default.createElement("span", {
        className: "others"
      }, checkedOptions.length - 1));
    }
  };

  var clearHandler = function clearHandler() {
    var tmpData = _toConsumableArray(newData);

    tmpData.map(function (item) {
      item.checked = false;
      return item;
    });
    onChange([]);
  };

  return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiPickListDropdown, {
    ref: dropdownRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, value.length > 0 ? formateTitle() : defaultTitle), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "optionsWrap"
  }, options && newData.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiCheckList, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      onChange: function onChange(e) {
        return checkboxChangeHandler(e, item);
      },
      checked: item.checked
    }, item.name));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "action"
  }, /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiClearButton, {
    disabled: value.length > 0 ? false : true,
    onClick: clearHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, null)), "\u6E05\u9664"))));
};

var _default = PickListDropdown;
/**
 * 客製化下拉選單(單選)
 */

exports.default = _default;

var SinglePickListDropdown = function SinglePickListDropdown(_ref2) {
  var _options$filter$;

  var _ref2$defaultTitle = _ref2.defaultTitle,
      defaultTitle = _ref2$defaultTitle === void 0 ? "defaultTitle" : _ref2$defaultTitle,
      value = _ref2.value,
      _ref2$displayType = _ref2.displayType,
      displayType = _ref2$displayType === void 0 ? "value" : _ref2$displayType,
      _ref2$clearable = _ref2.clearable,
      clearable = _ref2$clearable === void 0 ? false : _ref2$clearable,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      _ref2$onPickListClear = _ref2.onPickListClear,
      onPickListClear = _ref2$onPickListClear === void 0 ? function () {} : _ref2$onPickListClear;

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDropdownOpen = _useState6[0],
      setDropdownOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isHover = _useState8[0],
      setHover = _useState8[1];

  var dropdownRef = (0, _react.useRef)();
  (0, _useOnClickOutside.useOnClickOutside)(dropdownRef, function () {
    return setDropdownOpen(false);
  });

  var dropdownOpenHandler = function dropdownOpenHandler() {
    setDropdownOpen(!isDropdownOpen);
  };

  var checkboxCheckHandler = function checkboxCheckHandler(checkList) {
    onClick(checkList.value, checkList.name);
    dropdownOpenHandler();
  };

  var onClear = function onClear(event) {
    event.stopPropagation();
    onPickListClear();
  };

  return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiPickListDropdown, {
    ref: dropdownRef,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, displayType === "value" ? value ? value : defaultTitle : value && options.length > 0 ? (_options$filter$ = options.filter(function (item) {
    return item.value === value;
  })[0]) === null || _options$filter$ === void 0 ? void 0 : _options$filter$.name : defaultTitle), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, isHover && clearable ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "close",
    color: "#fff",
    onClick: function onClick(event) {
      return onClear(event);
    }
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "optionsWrap"
  }, options && options.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiCheckList, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_PickListDropdown.SingleList, {
      onClick: function onClick() {
        return checkboxCheckHandler(item);
      }
    }, item.name));
  }))));
};
/**
 * tab切換多選下拉選單
 */


exports.SinglePickListDropdown = SinglePickListDropdown;

var TabPickListDropdown = function TabPickListDropdown(_ref3) {
  var _ref3$defaultTitle = _ref3.defaultTitle,
      defaultTitle = _ref3$defaultTitle === void 0 ? "題型" : _ref3$defaultTitle,
      _ref3$checkedList = _ref3.checkedList,
      checkedList = _ref3$checkedList === void 0 ? {} : _ref3$checkedList,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      _ref3$onChange = _ref3.onChange,
      _onChange = _ref3$onChange === void 0 ? function () {} : _ref3$onChange,
      _ref3$onCheckAll = _ref3.onCheckAll,
      onCheckAll = _ref3$onCheckAll === void 0 ? function () {} : _ref3$onCheckAll;

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isDropdownOpen = _useState10[0],
      setDropdownOpen = _useState10[1];

  var dropdownRef = (0, _react.useRef)();
  (0, _useOnClickOutside.useOnClickOutside)(dropdownRef, function () {
    return setDropdownOpen(false);
  });

  var dropdownOpenHandler = function dropdownOpenHandler() {
    setDropdownOpen(!isDropdownOpen);
  };

  var checkAll = function checkAll(checked, val) {
    var nextData = checked ? val.subMap.map(function (item) {
      return item.value;
    }) : [];
    onCheckAll(nextData, [val.value]);
  };

  var calAllCheckedCount = (0, _react.useMemo)(function () {
    var count = 0;
    if (Object.keys(checkedList).length === 0) return count;
    Object.entries(checkedList).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          value = _ref5[1];

      value.forEach(function () {
        count++;
      });
    });
    return count;
  }, [Object.keys(checkedList).length]);
  return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiPickListDropdown, {
    ref: dropdownRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, defaultTitle, calAllCheckedCount ? /*#__PURE__*/_react.default.createElement("span", {
    className: "others"
  }, calAllCheckedCount) : ""), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "optionsWrap tabs"
  }, /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    defaultActiveKey: "1"
  }, options && options.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
      tab: /*#__PURE__*/_react.default.createElement("div", {
        className: "tabHeader"
      }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
        checked: checkedList[item.value] && checkedList[item.value].length === item.subMap.length,
        onChange: function onChange(e) {
          checkAll(e.target.checked, item);
        }
      }), item.name, checkedList[item.value] ? /*#__PURE__*/_react.default.createElement("span", {
        className: "tabCheckCount"
      }, checkedList[item.value].length) : ""),
      key: item.value
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox.Group, {
      value: checkedList[item.value] || [],
      options: item.subMap.map(function (optionItem) {
        return {
          label: optionItem.name,
          value: optionItem.value
        };
      }),
      onChange: function onChange(val) {
        _onChange && _onChange(val, item.value);
      }
    }));
  })))));
};

exports.TabPickListDropdown = TabPickListDropdown;
PickListDropdown.propTypes = {
  defaultTitle: _propTypes.default.string,
  value: _propTypes.default.array,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  onChange: _propTypes.default.func
};
SinglePickListDropdown.propTypes = {
  defaultTitle: _propTypes.default.string,
  value: _propTypes.default.any,
  clearable: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  onClick: _propTypes.default.func,
  onPickListClear: _propTypes.default.func,
  displayType: _propTypes.default.string
};
TabPickListDropdown.propTypes = {
  defaultTitle: _propTypes.default.string,
  checkedList: _propTypes.default.object,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  onChange: _propTypes.default.func,
  onCheckAll: _propTypes.default.func
};